import React from 'react'
import { ItemDetails, PeopleList } from 'components'
import { useIsSmallScreen } from 'packages/core'
import { Box, styled } from '@mui/material'
import { useManagementRoleOwners, useResponsibleParty } from 'hooks'
import { useTranslation } from 'react-i18next'
import useSubcomponents from 'useSubcomponents'
import { PersonDetails } from 'components/ApplicationBanner/PersonDetails'

const hasAccessToOwnerControl = 'ITShop-ManagementRoles-Details-Owners-Control'
const hasAccessToResponsiblePartyControl = 'ITShop-ManagementRoles-Details-ResponsibleParty-Control'

const PaddedDiv = styled(Box)({
    padding: '0 31px',
})

export const MoreInformationSection = ({ managementRole }: any) => {
    const { t } = useTranslation()
    const { hasAccessToControl } = useSubcomponents()
    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    const { data: owners, isInitialLoading: ownersLoading } =
        useManagementRoleOwners(
            hasAccessToControl(hasAccessToOwnerControl)
                ? managementRole.id
                : null,
        )

    const {
        data: responsibleParty,
        isInitialLoading: responsiblePartyLoading,
    } = useResponsibleParty(
        managementRole.id,
        Boolean(hasAccessToControl(hasAccessToResponsiblePartyControl))
    )

    return (
        <>
            {ownersLoading || responsiblePartyLoading ? (
                <ItemDetails.AttributesContainer
                    data-ai-explain="Loading more information for this management role (owners and responsible party)."
                >
                    <PaddedDiv>
                        <ItemDetails.AttributesLoader />
                    </PaddedDiv>
                </ItemDetails.AttributesContainer>
            ) : (
                owners && (
                    <ItemDetails.AttributesContainer
                        bottomPadding="0"
                        data-ai-explain="Management role more information: owners and responsible party when your permissions allow."
                    >
                        {hasAccessToControl(hasAccessToOwnerControl) && (
                            <PaddedDiv
                                data-protectedsubcomponent={
                                    hasAccessToOwnerControl
                                }
                                data-ai-explain="People or groups who own this management role."
                            >
                                <ItemDetails.Attribute
                                    label={t('ManagementRoles_Owners')}
                                    value={<PeopleList list={owners} />}
                                    orientation={attributeOrientation}
                                />
                            </PaddedDiv>
                        )}
                        {hasAccessToControl(hasAccessToResponsiblePartyControl) && (
                            <PaddedDiv
                                data-protectedsubcomponent={
                                    hasAccessToResponsiblePartyControl
                                }
                                data-ai-explain="Responsible party or primary owner contact for this management role."
                            >
                                <ItemDetails.Attribute
                                    label={t('Applications_Owner')}
                                    value={
                                        responsibleParty ?
                                            <PersonDetails
                                                size="medium"
                                                person={{
                                                    imageThumbUrl: responsibleParty.imageThumbUrl,
                                                    friendlyName: responsibleParty.friendlyName,
                                                    email: responsibleParty.email,
                                                    telephone: responsibleParty.telephone,
                                                }}
                                            />
                                            : <>-</>
                                    }
                                    orientation={attributeOrientation}
                                />
                            </PaddedDiv>
                        )}
                    </ItemDetails.AttributesContainer>
                )
            )}
        </>
    )
}
